// extracted by mini-css-extract-plugin
module.exports = {"article__body":"styles_article__body__npFhc","article":"styles_article__9ZmUM","sidebar":"styles_sidebar__LYsqW","sidebar2":"styles_sidebar2__DzQYA"};